export default __webpack_public_path__ + "static/media/JPYC.49726de2.png";